import type { UserAuth } from '~/schemas/auth'

export default defineNuxtPlugin(async () => {
  const { user, isAuthenticated } = useSanctumAuth<UserAuth>()
  const roleStore = useUserRoleStore()

  watch(
    [user, isAuthenticated],
    ([newUser, isLoggedIn]) => {
      if (isLoggedIn && newUser) {
        roleStore.initializeFromAuth()
      } else {
        roleStore.reset()
      }
    },
    { immediate: true }
  )
})
